import WorkflowStepNode from "./WorkflowStepNode";

export const nodeTypes = {
  workflowStep: WorkflowStepNode,
};

export { WorkflowStepNode };
